import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {QuotationService} from "../../../services/quotation-service/quotation.service";
import {ValidationService} from "../../../services/validation-service/validation.service";
import {LeadService} from "../../../services/lead-service/lead.service";
import {ErrorMessages} from "../../../model/ErrorMessages";
import {WebLeadType} from "../../../model/leads/WebLeadType";
import {GtmService} from "../../../services/gtm-service/gtm.service";
import {ErrorCodes} from "../../../model/ErrorCodes";
import {GetListsResponse} from "../../../model/GetListsResponse";
import {ClientDetails} from "../../../model/ClientDetails";

declare var $: any;
declare let jQuery: any;
declare let jcf: any;

@Component({
  selector: 'app-quote-step-one',
  templateUrl: './quote-step-one.component.html'
})
export class QuoteStepOneComponent implements OnInit, AfterViewInit {
  showSpinner = false;
  showActiveProductFragment = false;
  errorMessage = ErrorMessages;
  yearsWithPreviousInsurerCd = null;
  isMobileLead = false;
  @ViewChild('openModal') openModal: ElementRef;
  @ViewChild('formStart') formStart: ElementRef;

  constructor(public router: Router,
              public quotationService: QuotationService,
              public validationService: ValidationService,
              private leadService: LeadService,
              private gtmService: GtmService,
              private location: Location) { }

  ngOnInit() {
    this.quotationService.loadScreen('aboutYourself').subscribe((response: GetListsResponse) => {
      this.quotationService.yearsAtPreviousInsurerSelectItemList = response.yearsAtPreviousInsurerSelectItemList;
      this.quotationService.genderSelectItemList = response.genderSelectItemList;
    }, error => {
      this.quotationService.error = true;
    });
    this.validationService.retrievedLoggedInUser();
    this.reloadJCF();
    if (localStorage.getItem('leadReferenceNumbers')) {
      const leadRef = localStorage.getItem('leadReferenceNumbers').trim();
      this.isMobileLead = true;
      this.leadService.createLeadResponse.leadReferenceNumber = +leadRef;
      this.leadService.cacheLeadReference(leadRef).subscribe();
    }
  }

  ngAfterViewInit() {
    this.quotationService.scrollToPosition(this.formStart.nativeElement.getBoundingClientRect().top);
  }

  private reloadJCF() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  isUserLoggedIn() {
    return this.validationService.loggedIn;
  }

  get maxDateOfBirth() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    return date.toISOString().substr(0, 10);
  }

  get isLeadReadyToSubmit(): boolean {
    return this.validationService.isNameValid() && this.validationService.isSurnameValid() && this.validationService.isCellPhoneValid() &&
      (this.validationService.isIDValid() || this.validationService.isPassportValid());
  }

  get isFormValid(): boolean {
    return this.validationService.isNameValid() && this.validationService.isSurnameValid() && this.validationService.isCellPhoneValid() &&
      this.validationService.isEmailValid() && this.yearsWithPreviousInsurerCd && this.quotationService.quotationRequest.isConsentGiven &&
      (this.leadService.createLeadResponse.leadReferenceNumber != null || this.leadService.doesUserHaveProduct === true) &&
      (this.validationService.isIDValid() || (this.validationService.isPassportValid() &&
        this.quotationService.quotationRequest.dateOfBirth <= this.maxDateOfBirth && this.quotationService.quotationRequest.gender != null));
  }

  submitLead() {
    this._trimValues();
    if (this.isLeadReadyToSubmit && !this.isMobileLead) {
      this.quotationService.quotationRequest.medium = '60 second quote';
      this.quotationService.quotationRequest.campaign = localStorage.getItem('campaign');
      this.quotationService.quotationRequest.urlParams = localStorage.getItem('lead_url_params') != null ? encodeURIComponent(localStorage.getItem('lead_url_params')) : null;
      this.leadService.originNode = localStorage.getItem('url');
      this.leadService.registerLead(WebLeadType.WEB_LEAD_4).subscribe(response => {
        this.leadService.createLeadResponse = response.body;
        this.gtmService.formName = 'insure_60_second_quote';
        this.gtmService.leadRef = this.leadService.createLeadResponse.leadReferenceNumber;
        this.gtmService.postGtmEvent('generate_lead_ninja','submit_personal_details', 1);
      }, error => {
        if (error.status === ErrorCodes['USER_HAS_PRODUCT']) {
          this.leadService.doesUserHaveProduct = true;
        } else {
          this.quotationService.error = true;
        }
      });
    }
  }

  private _trimValues() {
    if (this.quotationService.quotationRequest.name) {
      this.quotationService.quotationRequest.name = this.quotationService.quotationRequest.name.trim();
    }
    if (this.quotationService.quotationRequest.surname) {
      this.quotationService.quotationRequest.surname = this.quotationService.quotationRequest.surname.trim();
    }
    if (this.quotationService.quotationRequest.cellphone) {
      this.quotationService.quotationRequest.cellphone = this.quotationService.quotationRequest.cellphone.trim();
    }
  }

  submitForm() {
    this.showSpinner = true;
    if (this.leadService.doesUserHaveProduct) {
      this.openModal.nativeElement.click();
      this.quotationService.scrollToTop();
      this.showSpinner = false;
    } else {
      this.quotationService.checkQuoteEligibility(this.getClientDetailsRequest()).subscribe(response => {
        if (response === true) {
          this.setLeadComment();
          this.leadService.updateLead(WebLeadType.WEB_LEAD_3, null, null, null, null,
             this.isMobileLead ? 'MOBILE' : null, this.isMobileLead ? 'WEBSITE' : null).subscribe(response => {
            this.gtmService.postGtmEvent('generate_lead', 'submit_personal_details', 1);
            this.gtmService.postGtmEvent('form_step_complete', 'submit_your_details', 2);
            this.quotationService.maxDateOfBirth = this.maxDateOfBirth;
            this.router.navigateByUrl('quote-step-two');
          })
        } else {
          this.showSpinner = false;
          this.quotationService.error = true;
        }
      }, error => {
        this.showSpinner = false;
        this.quotationService.error = true;
      })
    }
  }

  fireAbandonmentTrackingEvent(fieldValue: string, fieldName: string) {
    if (fieldValue && !this._isAbandonmentTrackingFired(fieldName)) {
      this.gtmService.formName = 'insure_60_second_quote';
      this.gtmService.postGtmEvent('form_abandoned', fieldName, 2);
      this._setTrackingFiredOnField(fieldName);
    }

  }

  private _setTrackingFiredOnField(fieldName: string) {
    switch (fieldName) {
      case 'dob' : {
        this.gtmService.dobFieldAbandonmentTrackingFired = true;
        break;
      }
    }
  }

  private _isAbandonmentTrackingFired(fieldName: string): boolean {
    switch (fieldName) {
      case 'dob' : return this.gtmService.dobFieldAbandonmentTrackingFired;
    }
  }

  private setLeadComment() {
    const yearsPrevInsurer = this.quotationService.yearsAtPreviousInsurerSelectItemList.find(item => item.key === this.yearsWithPreviousInsurerCd).label;
    this.leadService.leadComment = 'YrsPrevInsurer:' + yearsPrevInsurer;
    if (this.quotationService.quotationRequest.legalRefType === 'PS') {
      this.leadService.leadComment += '|DOB:' + this.quotationService.quotationRequest.dateOfBirth
        + '|Gender:' + this.quotationService.quotationRequest.gender;
    }
  }

  goBack() {
    this.location.back();
  }

  private getClientDetailsRequest(): ClientDetails {
    const clientDetails: ClientDetails = {
      firstName: this.quotationService.quotationRequest.name,
      surname: this.quotationService.quotationRequest.surname,
      legalRefValue: this.quotationService.quotationRequest.idNumber,
      legalRefTypeCd: 1,
      cellphoneNumber: this.quotationService.quotationRequest.cellphone,
      emailAddress: this.quotationService.quotationRequest.email,
      yearsAtPreviousInsurerCd: this.yearsWithPreviousInsurerCd
    }
    if (this.quotationService.quotationRequest.legalRefType === 'PS') {
      clientDetails.legalRefTypeCd = 2;
      clientDetails.legalRefValue = this.quotationService.quotationRequest.passportNumber;
      clientDetails.gender = this.quotationService.quotationRequest.gender;
      clientDetails.dateOfBirth = this.quotationService.quotationRequest.dateOfBirth + ' 00:00';
    }
    return clientDetails;
  }

  login() {
    const defaultRoute = '/portal/ddid/login.do?dest=/car-and-home-insurance/manage-your-policy';
    this.quotationService.getExistingClientLoginRoute().subscribe((response: string) => {
      window.parent.location.href = response != null ? response : defaultRoute;
    }, error => {
      window.parent.location.href = defaultRoute;
    });
  }
}

